// extracted by mini-css-extract-plugin
export default {"wrapper":"Vu-z","addressLine":"Wu-z","fullName":"Xu-z"};